import { render, staticRenderFns } from "./uf_industry_id_markirovka.vue?vue&type=template&id=fa5af4a8&scoped=true"
import script from "./uf_industry_id_markirovka.vue?vue&type=script&lang=js"
export * from "./uf_industry_id_markirovka.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5af4a8",
  null
  
)

export default component.exports